import React, { useMemo } from 'react';
import { ReactComponent as Visa } from 'assets/app-images/custom-icons/visa.svg';
import { ReactComponent as MasterCard } from 'assets/app-images/custom-icons/mastercard.svg';
import { ReactComponent as Discover } from 'assets/app-images/custom-icons/discover.svg';
import { ReactComponent as AmericanExpress } from 'assets/app-images/custom-icons/amex.svg';
import { ReactComponent as UnionPay } from 'assets/app-images/custom-icons/unionpay.svg';
import { ReactComponent as DinersClub } from 'assets/app-images/custom-icons/dinersclub.svg';
import { ReactComponent as JCBIcon } from 'assets/app-images/custom-icons/jcb.svg';
import { Enums } from 'services/dropdown-enums';

const CardType = ({ paymentCardType, Last4Digits, onlyIcon = false }) => {
  const CardIcon = useMemo(() => {
    switch (paymentCardType) {
      case Enums.CardTypes.Visa:
        return Visa;
      case Enums.CardTypes.MasterCard:
        return MasterCard;
      case Enums.CardTypes.Discover:
        return Discover;
      case Enums.CardTypes.AmericanExpress:
        return AmericanExpress;
      case Enums.CardTypes.UnionPay:
        return UnionPay;
      case Enums.CardTypes.DinersClub:
        return DinersClub;
      case Enums.CardTypes.JCB:
        return JCBIcon;
      default:
        return null;
    }
  }, [paymentCardType]);

  if (!CardIcon) return null;

  return onlyIcon ? (
    <CardIcon style={{ width: 70, height: 'auto' }} />
  ) : (
    <span className="d-flex align-items-center">
      <CardIcon style={{ width: 40, height: 'auto' }} />
      <span className="ml-1">{Last4Digits}</span>
    </span>
  );
};

export default CardType;
